import * as React from "react";
import { renderOutrightMarkets } from "../LiveOutright";
import * as RenderMethods from "./RenderMethods";
export class MiniOutright extends React.Component {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
        this.renderOutrightDetails = RenderMethods.renderMiniOutrightDetails;
        this.renderMarkets = renderOutrightMarkets;
        this.componentPrefix = "mini-outright";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;
    }
    render() {
        const isSelected = this.props.event.isSelected ? `rj-ev-list__${this.componentPrefix}--selected` : "";
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix} ${isSelected}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                this.renderOutrightDetails(this.props.event, this.props.handlers, this.props.isFavoritesEnabled, this.componentPrefix),
                this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix))));
    }
}
//# sourceMappingURL=MiniOutright.js.map